// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables */
:root {
  --primary-color: #ffa058;
  --secondary-color: #1f1f1f;
  --accent-color: #ff7a33;
  --text-color: #e0e0e0;
  --background-color: #121212;
  --success-color: #00b894;
  --danger-color: #d63031;
  --warning-color: #f39c12;
  --info-color: #0984e3;
  --light-color: #f1f2f6;
  --dark-color: #2d3436;
  --border-color: #333;
  --shadow-color: rgba(0, 0, 0, 0.5);
}

/* General Styles */
body {
  font-family: 'Roboto', sans-serif;
  line-height: 1.75;
  margin: 0;
  padding: 0;
  height: auto;
  min-height: 100vh;
  background-color: var(--background-color);
  color: var(--text-color);
  transition: all 0.3s ease;
  background-image:
    radial-gradient(
      var(--secondary-color),
      rgba(255, 255, 255, 0.2) 5px,
      transparent 40px
    ),
    radial-gradient(
      var(--success-color),
      rgba(255, 255, 255, 0.15) 1px,
      transparent 30px
    ),
    radial-gradient(
      var(--success-color),
      rgba(255, 255, 255, 0.1) 2px,
      transparent 40px
    ),
    radial-gradient(
      rgba(255, 255, 255, 0.4),
      rgba(255, 255, 255, 0.1) 2px,
      transparent 30px
    );
  background-size:
    550px 550px,
    350px 350px,
    250px 250px,
    150px 150px;
  background-position:
    0 0,
    40px 60px,
    130px 270px,
    70px 100px;
}

.root {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Container */
.container {
  max-width: 900px;
  margin: 40px auto;
  padding: 30px;
  background-color: var(--secondary-color);
  box-shadow: 0 4px 20px var(--shadow-color);
  border-radius: 8px;
  transition: all 0.3s ease;
  border: 2px solid var(--success-color);
}

/* Headings */
h1 {
  font-size: 3em;
  text-align: center;
  margin-bottom: 15px;
  color: var(--primary-color);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}

h1 small {
  font-size: 0.5em;
  display: block;
  margin-top: 10px;
  font-weight: 300;
  color: #d1d1d1;
}

h2 {
  font-size: 2.25em;
  margin-top: 40px;
  border-bottom: 3px solid var(--primary-color);
  padding-bottom: 15px;
  color: var(--primary-color);
  text-transform: uppercase;
}

h3 {
  font-size: 1.75em;
  margin-top: 30px;
  color: var(--accent-color);
}

h4 {
  font-size: 1.5em;
  margin-top: 25px;
  color: #ffc18e;
}

/* Paragraphs */
p {
  margin: 20px 0;
  font-size: 1.1em;
  color: #d1d1d1;
}

/* Lists */
ol,
ul {
  margin-left: 25px;
  margin-bottom: 25px;
}

li {
  margin-bottom: 12px;
  font-size: 1.05em;
  color: #d1d1d1;
}

/* Code Blocks */
code {
  background-color: #2e2e2e;
  border: 1px solid var(--border-color);
  padding: 4px 8px;
  border-radius: 4px;
  color: var(--primary-color);
  font-family: 'Courier New', Courier, monospace;
}

/* Links */
a {
  color: var(--primary-color);
  text-decoration: none;
  transition: color 0.2s ease;
}

a:hover {
  color: var(--accent-color);
  text-decoration: underline;
}

/* Horizontal Rule */
hr {
  border: 0;
  height: 2px;
  background: var(--primary-color);
  margin: 50px 0;
}

/* Table of Contents */
ol a {
  font-size: 1.1em;
  color: var(--accent-color);
}

ol a:hover {
  color: var(--accent-color);
}

/* Special Text Classes */
.tip {
  background-color: #292929;
  border-left: 8px solid var(--primary-color);
  padding: 15px;
  margin: 30px 0;
  border-radius: 4px;
  color: var(--accent-color);
  font-style: italic;
}

.author {
  font-size: 1.1em;
  color: var(--accent-color);
  text-align: center;
}

/* Table Styles */
table {
  width: 100%;
  border-collapse: collapse;
  margin: 30px 0;
  background-color: var(--secondary-color);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px var(--shadow-color);
}

th,
td {
  border: 1px solid var(--border-color);
  padding: 12px;
  text-align: center;
  font-size: 1em;
  color: var(--text-color);
}

th {
  background-color: var(--primary-color);
  color: var(--background-color);
  font-weight: bold;
}

td {
  background-color: #2e2e2e;
}

tr:nth-child(even) td {
  background-color: #242424;
}

/* Emphasized Text */
em {
  font-style: italic;
  color: var(--accent-color);
}

/* Table of Contents Buttons */
ol button {
  background-color: transparent;
  border: none;
  color: var(--accent-color);
  cursor: pointer;
  font-size: 1.1em;
  text-align: left;
  width: 100%;
  padding: 5px 0;
  transition:
    color 0.2s ease,
    background-color 0.2s ease;
}

ol button:hover {
  color: var(--accent-color);
  background-color: rgba(255, 255, 255, 0.1);
  text-decoration: underline;
}

/* Pagination Buttons */
.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}

.pagination button {
  background-color: var(--primary-color);
  border: none;
  border-radius: 4px;
  color: var(--background-color);
  cursor: pointer;
  font-size: 1em;
  padding: 8px 16px;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;
}

.pagination button:hover {
  background-color: var(--accent-color);
  color: #ffffff;
}

.pagination button:disabled {
  background-color: #b3b3b3;
  color: #666666;
  cursor: not-allowed;
}

.pagination span {
  color: #d1d1d1;
  font-size: 1em;
}

/* Table of Contents Button */
#toc-button {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: var(--primary-color);
  color: var(--background-color);
  border: none;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  font-size: 1.2em;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 4px 10px var(--shadow-color);
  transition:
    background-color 0.2s ease,
    transform 0.2s ease;
  z-index: 1000; /* Ensure it stays on top of other elements */
}

#toc-button:hover {
  background-color: var(--accent-color);
  transform: scale(1.1);
}

#toc-button:focus {
  outline: none;
}

/* Responsive Design */
@media (max-width: 768px) {
  .container {
    padding: 20px;
    margin: 20px;
  }

  .pagination {
    padding-right: 0;
  }

  h1 {
    font-size: 2em;
  }

  h2 {
    font-size: 1.75em;
  }

  h3 {
    font-size: 1.5em;
  }

  h4 {
    font-size: 1.25em;
  }

  #toc-button {
    top: 10px;
    right: 10px;
    width: 50px;
    height: 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA,mBAAmB;AACnB;EACE,iCAAiC;EACjC,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;EACzC,wBAAwB;EACxB,yBAAyB;EACzB;;;;;;;;;;;;;;;;;;;;KAoBG;EACH;;;;eAIa;EACb;;;;cAIY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,wCAAwC;EACxC,0CAA0C;EAC1C,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA,aAAa;AACb;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6CAA6C;EAC7C,oBAAoB;EACpB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,UAAU;AACV;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;;EAEE,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,8BAA8B;AAC9B;EACE,6BAA6B;EAC7B,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd;;8BAE4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB;;mBAEiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,WAAW;EACX,sCAAsC;EACtC,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C;;uBAEqB;EACrB,aAAa,EAAE,6CAA6C;AAC9D;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Variables */\n:root {\n  --primary-color: #ffa058;\n  --secondary-color: #1f1f1f;\n  --accent-color: #ff7a33;\n  --text-color: #e0e0e0;\n  --background-color: #121212;\n  --success-color: #00b894;\n  --danger-color: #d63031;\n  --warning-color: #f39c12;\n  --info-color: #0984e3;\n  --light-color: #f1f2f6;\n  --dark-color: #2d3436;\n  --border-color: #333;\n  --shadow-color: rgba(0, 0, 0, 0.5);\n}\n\n/* General Styles */\nbody {\n  font-family: 'Roboto', sans-serif;\n  line-height: 1.75;\n  margin: 0;\n  padding: 0;\n  height: auto;\n  min-height: 100vh;\n  background-color: var(--background-color);\n  color: var(--text-color);\n  transition: all 0.3s ease;\n  background-image:\n    radial-gradient(\n      var(--secondary-color),\n      rgba(255, 255, 255, 0.2) 5px,\n      transparent 40px\n    ),\n    radial-gradient(\n      var(--success-color),\n      rgba(255, 255, 255, 0.15) 1px,\n      transparent 30px\n    ),\n    radial-gradient(\n      var(--success-color),\n      rgba(255, 255, 255, 0.1) 2px,\n      transparent 40px\n    ),\n    radial-gradient(\n      rgba(255, 255, 255, 0.4),\n      rgba(255, 255, 255, 0.1) 2px,\n      transparent 30px\n    );\n  background-size:\n    550px 550px,\n    350px 350px,\n    250px 250px,\n    150px 150px;\n  background-position:\n    0 0,\n    40px 60px,\n    130px 270px,\n    70px 100px;\n}\n\n.root {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n/* Container */\n.container {\n  max-width: 900px;\n  margin: 40px auto;\n  padding: 30px;\n  background-color: var(--secondary-color);\n  box-shadow: 0 4px 20px var(--shadow-color);\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  border: 2px solid var(--success-color);\n}\n\n/* Headings */\nh1 {\n  font-size: 3em;\n  text-align: center;\n  margin-bottom: 15px;\n  color: var(--primary-color);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n}\n\nh1 small {\n  font-size: 0.5em;\n  display: block;\n  margin-top: 10px;\n  font-weight: 300;\n  color: #d1d1d1;\n}\n\nh2 {\n  font-size: 2.25em;\n  margin-top: 40px;\n  border-bottom: 3px solid var(--primary-color);\n  padding-bottom: 15px;\n  color: var(--primary-color);\n  text-transform: uppercase;\n}\n\nh3 {\n  font-size: 1.75em;\n  margin-top: 30px;\n  color: var(--accent-color);\n}\n\nh4 {\n  font-size: 1.5em;\n  margin-top: 25px;\n  color: #ffc18e;\n}\n\n/* Paragraphs */\np {\n  margin: 20px 0;\n  font-size: 1.1em;\n  color: #d1d1d1;\n}\n\n/* Lists */\nol,\nul {\n  margin-left: 25px;\n  margin-bottom: 25px;\n}\n\nli {\n  margin-bottom: 12px;\n  font-size: 1.05em;\n  color: #d1d1d1;\n}\n\n/* Code Blocks */\ncode {\n  background-color: #2e2e2e;\n  border: 1px solid var(--border-color);\n  padding: 4px 8px;\n  border-radius: 4px;\n  color: var(--primary-color);\n  font-family: 'Courier New', Courier, monospace;\n}\n\n/* Links */\na {\n  color: var(--primary-color);\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\na:hover {\n  color: var(--accent-color);\n  text-decoration: underline;\n}\n\n/* Horizontal Rule */\nhr {\n  border: 0;\n  height: 2px;\n  background: var(--primary-color);\n  margin: 50px 0;\n}\n\n/* Table of Contents */\nol a {\n  font-size: 1.1em;\n  color: var(--accent-color);\n}\n\nol a:hover {\n  color: var(--accent-color);\n}\n\n/* Special Text Classes */\n.tip {\n  background-color: #292929;\n  border-left: 8px solid var(--primary-color);\n  padding: 15px;\n  margin: 30px 0;\n  border-radius: 4px;\n  color: var(--accent-color);\n  font-style: italic;\n}\n\n.author {\n  font-size: 1.1em;\n  color: var(--accent-color);\n  text-align: center;\n}\n\n/* Table Styles */\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 30px 0;\n  background-color: var(--secondary-color);\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 15px var(--shadow-color);\n}\n\nth,\ntd {\n  border: 1px solid var(--border-color);\n  padding: 12px;\n  text-align: center;\n  font-size: 1em;\n  color: var(--text-color);\n}\n\nth {\n  background-color: var(--primary-color);\n  color: var(--background-color);\n  font-weight: bold;\n}\n\ntd {\n  background-color: #2e2e2e;\n}\n\ntr:nth-child(even) td {\n  background-color: #242424;\n}\n\n/* Emphasized Text */\nem {\n  font-style: italic;\n  color: var(--accent-color);\n}\n\n/* Table of Contents Buttons */\nol button {\n  background-color: transparent;\n  border: none;\n  color: var(--accent-color);\n  cursor: pointer;\n  font-size: 1.1em;\n  text-align: left;\n  width: 100%;\n  padding: 5px 0;\n  transition:\n    color 0.2s ease,\n    background-color 0.2s ease;\n}\n\nol button:hover {\n  color: var(--accent-color);\n  background-color: rgba(255, 255, 255, 0.1);\n  text-decoration: underline;\n}\n\n/* Pagination Buttons */\n.pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.pagination button {\n  background-color: var(--primary-color);\n  border: none;\n  border-radius: 4px;\n  color: var(--background-color);\n  cursor: pointer;\n  font-size: 1em;\n  padding: 8px 16px;\n  transition:\n    background-color 0.2s ease,\n    color 0.2s ease;\n}\n\n.pagination button:hover {\n  background-color: var(--accent-color);\n  color: #ffffff;\n}\n\n.pagination button:disabled {\n  background-color: #b3b3b3;\n  color: #666666;\n  cursor: not-allowed;\n}\n\n.pagination span {\n  color: #d1d1d1;\n  font-size: 1em;\n}\n\n/* Table of Contents Button */\n#toc-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  background-color: var(--primary-color);\n  color: var(--background-color);\n  border: none;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  font-size: 1.2em;\n  font-weight: bold;\n  text-align: center;\n  cursor: pointer;\n  box-shadow: 0 4px 10px var(--shadow-color);\n  transition:\n    background-color 0.2s ease,\n    transform 0.2s ease;\n  z-index: 1000; /* Ensure it stays on top of other elements */\n}\n\n#toc-button:hover {\n  background-color: var(--accent-color);\n  transform: scale(1.1);\n}\n\n#toc-button:focus {\n  outline: none;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .container {\n    padding: 20px;\n    margin: 20px;\n  }\n\n  .pagination {\n    padding-right: 0;\n  }\n\n  h1 {\n    font-size: 2em;\n  }\n\n  h2 {\n    font-size: 1.75em;\n  }\n\n  h3 {\n    font-size: 1.5em;\n  }\n\n  h4 {\n    font-size: 1.25em;\n  }\n\n  #toc-button {\n    top: 10px;\n    right: 10px;\n    width: 50px;\n    height: 50px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
